export const extra_resource_book_constant = {
  CREATE_RESOURE_BOOK: "CREATE_RESOURE_BOOK",
  UPDATE_RESOURE_BOOK: "UPDATE_RESOURE_BOOK",
  DELETE_RESOURCE_BOOK: "DELETE_RESOURCE_BOOK",
  GET_RESOURCE_BOOK: "GET_RESOURCE_BOOK",
};

export const resource_types = {
  resource: "1wayResource",
  story: "1wayStory",
  informate: "informate",
  balcon: "balcon",
  conectándome: "conectándome",
  comunidad: "Comunidad",
  AP: "AP",
};
